import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Stack, Box, Toolbar, IconButton } from '@material-ui/core';
// components
import { useLocation } from 'react-router-dom';
import { MHidden } from '../../components/@material-extend';
import IdentityChooser from '../../components/nav/IdentityChooser';
import ThemeModeToggle from './ThemeModeToggle';

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

// list of paths that will include the identity chooser
const includeIdentityPaths = ['/racks', '/createrack', '/upload'];

const RootStyle = styled(Box)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72)
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3)
  }
}));

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const location = useLocation();
  // Only render identity chooser if the path matches one of the allowed paths
  const renderIdentity = includeIdentityPaths.some((path) => location.pathname.startsWith(path));
  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        <Stack
          data-testid="dasboard_navbar"
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ paddingY: '15px', width: '100%' }}
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <ThemeModeToggle />
          {renderIdentity && <IdentityChooser />}
          {/* <LoginBox psopover /> */}
          {/* <AccountPopover /> */}
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
